import { Box } from '@mui/material';
import Modal from '@mui/material/Modal';
import './style.scss';
import React from 'react';
import Button from '../button';
import { CloseIcon } from '../../../assets/icons/close-icon';
import { ReactNode } from 'react';

interface Props {
  children: React.ReactNode;
  heading?: string | React.ReactNode;
  open: boolean;
  handleClose?: () => void;
  className?: string;
  customId?: string;
  boxClassName?: string;
  buttons:
    | {
        buttonLabel: string;
        buttonType?: 'positive' | 'negative';
        butttonClassName?: string;
        buttonFunction?: () => void;
        disabled?: boolean;
        [_: string]: unknown;
      }[]
    | [];
  isFromDirectSaleOverview?: boolean;
}
export default function PopUpModal({
  open,
  handleClose,
  heading = '',
  children,
  buttons = [],
  boxClassName = '',
  className = '',
  isFromDirectSaleOverview = false,
  customId = '',
}: Props) {
  const childrenArray = React.Children.toArray(children);
  let DirectSaleArray: ReactNode[] = [];
  if (isFromDirectSaleOverview) {
    DirectSaleArray = [childrenArray.shift()];
  }
  return (
    <div>
      <Modal
        className="custom_modal"
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box className={`content-style ${boxClassName}`}>
          <div className="model-header popup">
            <div className="flex gap-3 items-center">
              {DirectSaleArray?.length > 0 && (
                <div> {DirectSaleArray?.map(val => val)}</div>
              )}
              <span className="heading">{heading}</span>
            </div>
            {handleClose && (
              <div onClick={handleClose} className="cursor-pointer">
                <CloseIcon />
              </div>
            )}
          </div>
          <div
            className={`model-content ${className}`}
            id={customId ? customId : 'scrollableDiv'}>
            {childrenArray.map(val => val)}
          </div>
          {buttons.length > 0 && (
            <div className="model-footer">
              <div className="bottom">
                {buttons?.map((button, index) => {
                  return (
                    <Button
                      key={index}
                      onClick={button?.buttonFunction}
                      label={button?.buttonLabel}
                      disabled={button?.disabled}
                      className={`button_1 ${button?.buttonType} ${button?.butttonClassName}`}
                      {...button}></Button>
                  );
                })}
              </div>
            </div>
          )}
        </Box>
      </Modal>
    </div>
  );
}
